import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface COMCRommsProps {
  onBack: () => void;
}

export default function COMCRomms({ onBack }: COMCRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Cost of Materials Consumed" />;
}


